import React, { Component } from 'react';
import testData from './testData';
import {
  filterCityCinemas,
  formatDayLabel,
  getPageContext,
  getCinemaFilmUrl,
  getSessionPriceLabel,
  getSessionsMeta,
  pluralizeSessions,
} from './helpers';

class FilmNetworkCinemas extends Component {
  constructor(props) {
    super(props);

    const pageContext = getPageContext();
    const isDev = process.env.NODE_ENV === 'dev';

    this.state = {
      city: pageContext?.city || (isDev ? testData.city : ''),
      filmUrl: pageContext?.filmUrl || (isDev ? testData.filmUrl : ''),
      currentCinemaId:
        pageContext?.currentCinemaId || (isDev ? testData.currentCinemaId : ''),
      cinemas: pageContext?.cinemas?.length
        ? pageContext.cinemas
        : isDev
          ? testData.cinemas
          : [],
      todayKey: pageContext?.todayKey || (isDev ? testData.today : ''),
      tomorrowKey: pageContext?.tomorrowKey || (isDev ? testData.tomorrow : ''),
      expandedCinemaId: null,
    };
  }

  toggleCinema = cinemaId => {
    this.setState(prevState => ({
      expandedCinemaId: prevState.expandedCinemaId === cinemaId ? null : cinemaId,
    }));
  };

  renderSessions = cinema => {
    const { filmUrl, todayKey, tomorrowKey } = this.state;
    const cinemaFilmUrl = getCinemaFilmUrl(cinema, filmUrl);
    const sessions = cinema.sessions || {};
    const dates = Object.keys(sessions);

    if (!dates.length) {
      return (
        <p className="film-network-cinemas__empty">
          На ближайшие дни сеансов нет
        </p>
      );
    }

    return dates.map(date => {
      const daySessions = (sessions[date] || []).filter(session => !session.del);

      if (!daySessions.length) {
        return null;
      }

      return (
        <div key={`${cinema.id}-${date}`} className="film-network-cinemas__day">
          <span className="film-network-cinemas__day-name">
            {formatDayLabel(date, todayKey, tomorrowKey)}
          </span>
          <ul className="timetable__list film-network-cinemas__sessions">
            {daySessions.map(session => {
              const itemClasses = [
                'timetable__item',
                `timetable__item--${session.format}`,
              ];

              if (session.disabled) {
                itemClasses.push('timetable__item--disabled');
              }

              return (
                <li key={session.id} className={itemClasses.join(' ')}>
                  <a href={cinemaFilmUrl}>
                    <span>{session.time}</span>
                    <span className="price">
                      {getSessionPriceLabel(session)}
                    </span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      );
    });
  };

  render() {
    const {
      city,
      cinemas,
      currentCinemaId,
      expandedCinemaId,
      todayKey,
      tomorrowKey,
    } = this.state;

    const visibleCinemas = filterCityCinemas(cinemas, city, currentCinemaId);

    if (!city || visibleCinemas.length === 0) {
      return null;
    }

    return (
      <section className="film-network-cinemas">
        <h2 className="film-network-cinemas__title">
          Другие кинотеатры сети в {city.toUpperCase()}
        </h2>

        <div className="film-network-cinemas__list">
          {visibleCinemas.map(cinema => {
            const isExpanded = expandedCinemaId === cinema.id;
            const sessionsMeta = getSessionsMeta(cinema, todayKey, tomorrowKey);
            const toggleLabel = isExpanded ? 'Скрыть сеансы' : 'Показать сеансы';

            return (
              <article
                key={cinema.id}
                className={`film-network-cinemas__item${
                  isExpanded ? ' film-network-cinemas__item--open' : ''
                }`}
              >
                <div className="film-network-cinemas__head">
                  <div className="film-network-cinemas__info">
                    <p className="film-network-cinemas__name">
                      {cinema.short_name}, {cinema.address}
                    </p>
                    {sessionsMeta ? (
                      <p className="film-network-cinemas__meta">
                        {sessionsMeta.label}{' '}
                        {pluralizeSessions(sessionsMeta.count)}
                      </p>
                    ) : null}
                  </div>

                  <button
                    type="button"
                    className="film-network-cinemas__toggle"
                    aria-expanded={isExpanded}
                    onClick={() => this.toggleCinema(cinema.id)}
                  >
                    <span>{toggleLabel}</span>
                    <svg width="12" height="8" aria-hidden="true">
                      <use href="/local/templates/comfortkino/static/img/icons/icons.svg#i-shev-down" />
                    </svg>
                  </button>
                </div>

                {isExpanded ? (
                  <div className="film-network-cinemas__body">
                    {this.renderSessions(cinema)}
                  </div>
                ) : null}
              </article>
            );
          })}
        </div>
      </section>
    );
  }
}

export default FilmNetworkCinemas;
